import React, { createContext, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const StripeContext = createContext();

const stripePromise = loadStripe(import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY);

export const StripeProvider = ({ children }) => {
  const stripeOptions = {
    // Global Stripe options with HoliYay branding
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#0ea5e9', // HoliYay blue
        colorBackground: '#ffffff',
        colorText: '#1e293b',
        colorDanger: '#ef4444',
        fontFamily: 'Inter, system-ui, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px',
        // Travel theme customizations
        colorIcon: '#0ea5e9',
        colorIconTab: '#64748b',
        colorSuccess: '#10b981',
        focusBoxShadow: '0 0 0 2px rgba(14, 165, 233, 0.2)',
        tabIconSelectedColor: '#0ea5e9'
      },
      rules: {
        '.Input': {
          padding: '12px 16px',
          fontSize: '16px'
        },
        '.Tab': {
          padding: '12px 16px',
          border: '1px solid #e2e8f0'
        },
        '.Tab--selected': {
          borderColor: '#0ea5e9',
          color: '#0ea5e9'
        }
      }
    }
  };

  return (
    <StripeContext.Provider value={{ stripePromise, stripeOptions }}>
      {children}
    </StripeContext.Provider>
  );
};

export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripeContext must be used within a StripeProvider');
  }
  return context;
};

export default StripeProvider;